import { disConnectPokoro, stopScan } from "../nativebridge/JsToNative";

export const PENDING_POKORO_PROFILE_TOAST_KEY =
  "_PENDING_POKORO_PROFILE_TOAST_V1_";
export const PENDING_POKORO_PROFILE_DISCONNECT_KEY =
  "_PENDING_POKORO_PROFILE_DISCONNECT_V1_";

/** 로그아웃·세션 초기화 시 다음 계정에 넘어가지 않도록 비움 */
export function clearPendingPokoroProfileReturn() {
  try {
    localStorage.removeItem(PENDING_POKORO_PROFILE_TOAST_KEY);
    localStorage.removeItem(PENDING_POKORO_PROFILE_DISCONNECT_KEY);
  } catch (e) {
    console.warn("[clearPendingPokoroProfileReturn]", e);
  }
}

/**
 * 포코로 설정 > 프로필 등록 완료 후 /pokoroSetting 으로 이동할 때:
 * 도착 화면에서 토스트 표시 및 BT 해제를 위해 localStorage 에 적재한다.
 */
export function queuePokoroProfileCompleteReturnToSetting(message) {
  try {
    localStorage.setItem(
      PENDING_POKORO_PROFILE_TOAST_KEY,
      JSON.stringify({ type: "success", message })
    );
    localStorage.setItem(PENDING_POKORO_PROFILE_DISCONNECT_KEY, "1");
  } catch (e) {
    console.warn("[queuePokoroProfileCompleteReturnToSetting]", e);
  }
}

/**
 * PokoroSetting 마운트 시 1회: 대기 중이면 스캔 중지·연결 해제·앱 연결 상태 반영 후 성공 토스트.
 */
export function applyPendingPokoroProfileReturnOnPokoroSetting({
  showSuccessToast,
  setGlobalPenStatus,
}) {
  const disconnectPending =
    localStorage.getItem(PENDING_POKORO_PROFILE_DISCONNECT_KEY) === "1";
  if (disconnectPending) {
    localStorage.removeItem(PENDING_POKORO_PROFILE_DISCONNECT_KEY);
    stopScan();
    disConnectPokoro();
    setGlobalPenStatus((prev) => ({
      ...prev,
      isConnect: false,
    }));
    // 네이티브 쪽 비동기 해제 대비 한 번 더 요청 + UI 연결 상태 재확인
    window.setTimeout(() => {
      stopScan();
      disConnectPokoro();
      setGlobalPenStatus((prev) => ({
        ...prev,
        isConnect: false,
      }));
    }, 200);
  }

  const raw = localStorage.getItem(PENDING_POKORO_PROFILE_TOAST_KEY);
  if (!raw) {
    return;
  }
  localStorage.removeItem(PENDING_POKORO_PROFILE_TOAST_KEY);
  try {
    const parsed = JSON.parse(raw);
    const msg = parsed?.message;
    if (typeof msg === "string" && parsed?.type === "success") {
      showSuccessToast(msg);
    }
  } catch {
    showSuccessToast(raw);
  }
}
